import React, { useState, useCallback, useEffect } from 'react';
import {
  IonRow,
  IonButton,
  IonSelect,
  IonSelectOption,
  IonCol,
} from '@ionic/react';
import { connect } from 'react-redux';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import moment, { Moment } from 'moment';
import API from '../../api/index';
import { logout, getCurrencyTypeFromToken } from '../../store';
import crossIcon from '../../assets/images/common/cross.svg';
import Dialog from '@material-ui/core/Dialog';
import { LedgerRecord } from '../../models/LedgerRecord';
import Spinner from '../../components/Spinner/Spinner';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import './AccountStatement.scss';
import {
  getTransactionNameByID,
  MarketTypeByEnumMap,
  MarketTypeByID,
  MarketTypeMap,
} from '../../util/stringUtil';
import AccountStatementRecord from './AccountStatementRecord';
import { useHistory } from 'react-router-dom';
import { CURRENCY_TYPE_FACTOR } from '../../constants/CurrencyTypeFactor';
import CompetitionsMenu from '../../components/ExchCompetitionsMenu/ExchCompetitionsMenu';
import REPORTING_API from '../../api-services/reporting-api';

type LedgerProps = {
  logout: Function;
};

const Ledger: React.FC<LedgerProps> = (props) => {
  const history = useHistory();
  const { logout } = props;
  const [errorMsg, setErrorMsg] = useState(null);
  const [dataflag, setdataflag] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);
  // const [filter, setFilter] = useState<string>('all');
  const filter = 'all';
  const [records, setRecords] = useState<LedgerRecord[]>([]);
  const [currpage, setcurrpage] = useState<number>(1);
  const [sortDesc, setsortDesc] = useState<boolean>(true);
  const [fromDate, setfromDate] = useState<Moment>(moment().subtract(7, 'd'));
  const [transaction, setTransaction] = useState<string>('-1');
  const [toDate, setToDate] = useState<Moment>(moment());
  const [showTransactionDetailsModal, setShowTransactionDetailsModal] =
    useState<boolean>(false);
  const [transactionDetails, setTransactionDetails] =
    useState<LedgerRecord>(null);
  const pageSize = 25;
  const cFactor = CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()];

  // Pagenation
  const [pageToken, setPageToken] = useState<string[]>(['']);
  const [nextPageToken, setNextPageToken] = useState<string>('');

  const fromDateChangeHandler = (d: Moment) => {
    setfromDate(d);
  };

  const toDateChangeHandler = (d: Moment) => {
    setToDate(d);
  };

  const nextpageHandler = () => {
    setLoading(true);
    setcurrpage(currpage + 1);
  };

  const prevpageHandler = () => {
    setLoading(true);
    setcurrpage(currpage - 1);
  };

  const sortOrderHandler = () => {
    setLoading(true);
    setsortDesc(!sortDesc);
  };

  const fetchRecords = useCallback(
    async (filter: string, currpage: number) => {
      setLoading(true);
      try {
        const response: any = await REPORTING_API.post(
          '/reports/v2/account-statement-report',
          {
            user: '',
            transactionGroup: 'all',
            transactionType: transaction,
            startDate: fromDate.startOf('day').toISOString(),
            endDate: toDate.endOf('day').toISOString(),
            pageSize: 25,
            pageToken: pageToken[pageToken.length - 1],
          },
          {
            headers: {
              Authorization: sessionStorage.getItem('jwt_token'),
              Accept: 'application/json',
            },
          }
        );

        let statements = response.data?.accountStatement;
        if (response.status === 200) {
          for (const statement of statements) {
            statement.amount = statement.amount / cFactor;
            statement.balanceAfter = statement.balanceAfter / cFactor;
          }
          setRecords([]);
          setRecords(statements);
          setNextPageToken(response.data.nextPageToken);
          setdataflag(1);
          setLoading(false);
        } else {
          setLoading(false);
          setErrorMsg(response.data.errorDescription);
        }
      } catch (err) {
        setLoading(false);
        setRecords([]);
        setErrorMsg(
          err.response?.data?.errorDescription
            ? err.response?.data?.errorDescription
            : 'Something went wrong'
        );
      }
    },
    [logout, transaction, fromDate, toDate, sortDesc, pageToken]
  );

  const onShowTransactionDetails = (row: LedgerRecord) => {
    // if (row.transactionsCount > 1) {
    //   let data = Object.assign({}, row);
    //   if (!data.transactionType) {
    //     data['transactionType'] = transaction;
    //   }
    //   data['fromDate'] = fromDate;
    //   data['toDate'] = toDate;
    //   history.push({
    //     pathname: '/market_account_statement',
    //     state: JSON.stringify(data),
    //   });
    // }
    // if (row.transactionsCount === 1) {
    setTransactionDetails(row);
    setShowTransactionDetailsModal(true);
  };
  // };

  useEffect(() => {
    fetchRecords(filter, currpage);
  }, [fetchRecords, filter, sortDesc]);

  const nextPage = () => {
    setLoading(true);
    setcurrpage(currpage + 1);
    if (nextPageToken) {
      setPageToken([...pageToken, nextPageToken]);
    }
    setLoading(false);
  };

  const prevPage = () => {
    setLoading(true);
    setcurrpage(currpage - 1);
    if (pageToken.length > 1) {
      let pagetokens = pageToken;
      pagetokens.pop();
      setPageToken([...pagetokens]);
    }
    setLoading(false);
  };

  return (
    <div className="report-page">
      <IonRow>
        <IonCol sizeMd="1.7" sizeLg="1.7" className="web-view">
          <div className="compt-menu-section">
            <div className="sticky-col">
              <CompetitionsMenu loggedIn={true} />
            </div>
          </div>
        </IonCol>

        <IonCol sizeXs="12" sizeSm="12" sizeMd="10.3" sizeLg="10.3">
          {' '}
          <div className="reports-ctn">
            <div className="carw">
              <div className="arrow arrow-right">Account Statement</div>
            </div>

            <IonRow className="filters-row">
              <IonCol sizeXs="12" sizeSm="12" sizeMd="12" sizeLg="12">
                <div className="filter-title">Filter:</div>
              </IonCol>
              <IonCol
                sizeXs="6"
                sizeSm="6"
                sizeMd="3"
                sizeLg="3"
                className="web-view"
              >
                <div className="select-filter">
                  {/* <div className="select-filter-label">Transaction Type</div> */}
                  <IonSelect
                    className="select-filter-control"
                    value={transaction}
                    placeholder="Select One"
                    interface="popover"
                    onIonChange={(e) => setTransaction(e.detail.value)}
                  >
                    <IonSelectOption value="-1">All</IonSelectOption>
                    <IonSelectOption value="2-3">
                      Deposit/Withdraw
                    </IonSelectOption>
                    <IonSelectOption value="27">Bet Settlement</IonSelectOption>
                    <IonSelectOption value="6-10-21-28-38-42">
                      Rollback
                    </IonSelectOption>
                    <IonSelectOption value="7-29">Voided</IonSelectOption>
                  </IonSelect>
                </div>
              </IonCol>

              <IonCol sizeXs="6" sizeSm="6" sizeMd="3" sizeLg="3">
                <div className="date-filter">
                  {/* <div className="date-filter-label">From</div> */}
                  <MuiPickersUtilsProvider utils={MomentUtils}>
                    <KeyboardDatePicker
                      disableFuture
                      className="date-filter-control"
                      InputProps={{
                        disableUnderline: true,
                        readOnly: true,
                      }}
                      disableToolbar
                      autoOk={true}
                      variant="inline"
                      minDate={moment().subtract(1, 'months').calendar()}
                      format="DD/MM/yyyy"
                      margin="normal"
                      id="from-date"
                      value={fromDate}
                      onChange={(e) => fromDateChangeHandler(e)}
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </IonCol>
              <IonCol sizeXs="6" sizeSm="6" sizeMd="3" sizeLg="3">
                <div className="date-filter">
                  {/* <div className="date-filter-label">To</div> */}
                  <MuiPickersUtilsProvider utils={MomentUtils}>
                    <KeyboardDatePicker
                      disableFuture
                      className="date-filter-control"
                      InputProps={{
                        disableUnderline: true,
                        readOnly: true,
                      }}
                      disableToolbar
                      autoOk={true}
                      variant="inline"
                      minDate={moment().subtract(1, 'months').calendar()}
                      format="DD/MM/yyyy"
                      margin="normal"
                      id="to-date"
                      value={toDate}
                      onChange={(e) => toDateChangeHandler(e)}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </IonCol>
              <IonCol sizeXs="6" sizeSm="6" sizeMd="3" sizeLg="3">
                <div className="select-filter mob-view">
                  {/* <div className="select-filter-label">Transaction Type</div> */}
                  <IonSelect
                    value={transaction}
                    className="select-filter-control"
                    placeholder="Select One"
                    interface="popover"
                    onIonChange={(e) => setTransaction(e.detail.value)}
                  >
                    <IonSelectOption value="-1">All</IonSelectOption>
                    <IonSelectOption value="2-3">
                      Deposit/Withdraw
                    </IonSelectOption>
                    <IonSelectOption value="27">Bet Settlement</IonSelectOption>
                    <IonSelectOption value="6-10-21-28-38-42">
                      Rollback
                    </IonSelectOption>
                    <IonSelectOption value="7-29">Voided</IonSelectOption>
                  </IonSelect>
                </div>
              </IonCol>
            </IonRow>

            <div className="myb-bets-div">
              <IonRow>
                {pageToken.length === 1 || loading ? null : (
                  <IonButton
                    className="myb-btn-prev"
                    onClick={(e) => prevPage()}
                    disabled={pageToken.length < 2}
                  >
                    Prev({currpage - 1})
                  </IonButton>
                )}
                {nextPageToken && !loading ? (
                  <IonButton
                    className="myb-btn-prev"
                    onClick={(e) => nextPage()}
                    disabled={!nextPageToken}
                  >
                    Next({currpage + 1})
                  </IonButton>
                ) : null}
              </IonRow>

              {loading ? (
                <>
                  <Spinner />
                  <div className="tbl-paceholder"></div>
                </>
              ) : (
                <>
                  <div className="mob-view">
                    {records.length > 0 ? (
                      records.map((row) => (
                        <Card
                          row={row}
                          showTransactionDetails={() => {
                            onShowTransactionDetails(row);
                          }}
                        />
                      ))
                    ) : (
                      <div className="report-card">
                        <div className="no-bets-msg">
                          {' '}
                          {errorMsg ? (
                            <div>{errorMsg} </div>
                          ) : (
                            <div>You have no transactions</div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="tbl-ctn web-view">
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead className="tbl-header-section">
                          <TableRow>
                            <TableCell className="web-view">
                              Place Date
                              <IconButton
                                aria-label="Change Order"
                                size="medium"
                                onClick={() => sortOrderHandler()}
                              >
                                {/* {sortDesc ? (
                          <TableSortLabel active={true} direction="desc" />
                        ) : (
                          <TableSortLabel active={true} direction="asc" />
                        )} */}
                              </IconButton>
                            </TableCell>
                            <TableCell className="transaction-col" align="left">
                              Transaction
                            </TableCell>
                            <TableCell className="web-view" align="left">
                              Event
                            </TableCell>
                            <TableCell className="web-view" align="left">
                              Market Type
                            </TableCell>
                            <TableCell align="left">Credit/Debit</TableCell>
                            {/* <TableCell align="left">Debit</TableCell> */}
                            <TableCell className="web-view" align="left">
                              Balance
                            </TableCell>
                            <TableCell className="web-view" align="left">
                              Transaction ID
                            </TableCell>
                            <TableCell className="web-view" align="left">
                              Remarks
                            </TableCell>
                            {/* <TableCell className="web-view" align="left">
                      Txn Count
                    </TableCell> */}
                          </TableRow>
                        </TableHead>
                        {records.length > 0 || dataflag === 0 ? (
                          <TableBody>
                            {records.map((row) => (
                              <Row
                                row={row}
                                showTransactionDetails={() => {
                                  onShowTransactionDetails(row);
                                }}
                              />
                            ))}
                          </TableBody>
                        ) : (
                          <TableBody>
                            <TableRow>
                              <TableCell className="no-data-row" colSpan={8}>
                                <div className="no-bets-msg">
                                  {' '}
                                  {errorMsg ? (
                                    <div>{errorMsg} </div>
                                  ) : (
                                    <div>You have no transactions</div>
                                  )}
                                </div>
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        )}
                      </Table>
                    </TableContainer>

                    <Dialog
                      open={showTransactionDetailsModal}
                      onClose={() => {
                        setTransactionDetails(null);
                        setShowTransactionDetailsModal(false);
                      }}
                      aria-labelledby="responsive-dialog-title"
                      fullWidth={true}
                      className="modal"
                    >
                      <div className="carw">
                        <div className="arrow arrow-right">Transactions</div>
                      </div>

                      <div className="modal-content">
                        <div
                          className="go-corner"
                          onClick={() => {
                            setTransactionDetails(null);
                            setShowTransactionDetailsModal(false);
                          }}
                        >
                          <img src={crossIcon} alt="crossIcon" />
                        </div>
                        {transactionDetails ? (
                          <AccountStatementRecord
                            tranDetails={transactionDetails}
                          />
                        ) : null}{' '}
                      </div>
                    </Dialog>
                    {/* <Modal
                    open={showTransactionDetailsModal}
                    title="Transaction Details"
                    closeHandler={() => {
                      setTransactionDetails(null);
                      setShowTransactionDetailsModal(false);
                    }}
                    size="md"
                  >
                    {transactionDetails ? (
                      <AccountStatementRecord
                        tranDetails={transactionDetails}
                      />
                    ) : null}
                  </Modal> */}
                  </div>
                </>
              )}

              <div className="myb-bets-div">
                {pageToken.length === 1 || loading ? null : (
                  <IonButton
                    className="myb-btn-prev"
                    onClick={(e) => prevPage()}
                    disabled={pageToken.length < 2}
                  >
                    Prev({currpage - 1})
                  </IonButton>
                )}
                {nextPageToken && !loading ? (
                  <IonButton
                    className="myb-btn-prev"
                    onClick={(e) => nextPage()}
                    disabled={!nextPageToken}
                  >
                    Next({currpage + 1})
                  </IonButton>
                ) : null}
              </div>
            </div>
          </div>
        </IonCol>
      </IonRow>
    </div>
  );
};

function Row(props: { row: LedgerRecord; showTransactionDetails: () => void }) {
  const { row, showTransactionDetails } = props;

  return (
    <React.Fragment>
      <TableRow
        onClick={showTransactionDetails}
        className={
          row.amount > 0 ? 'profit-bg' : row.amount < 0 ? 'loss-bg' : 'row-bg'
        }
      >
        <TableCell
          scope="row"
          className={
            row.amount > 0
              ? 'profit-th web-view'
              : row.amount < 0
              ? 'loss-th web-view'
              : 'row-th web-view'
          }
        >
          {moment(row.transactionTime).format('DD-MM-YY, h:mm:ss A')}
        </TableCell>
        <TableCell align="left">
          <div className="b-text m-link web-view">
            {getTransactionNameByID(row.transactionType)}
          </div>
        </TableCell>
        <TableCell className="web-view" align="left">
          <span className="txt-bldin-mob">{row.eventName || '-'}</span>
        </TableCell>
        <TableCell className="web-view" align="left">
          <span className="txt-bldin-mob">
            {/* {Number(row.transactionType) <= 3
              ? '-'
              : row.marketType === 1
              ? row.marketName || MarketTypeByID(row.marketType.toString())
              : row.marketType === -1
              ? ''
              : MarketTypeByID(row.marketType.toString())} */}
            {/* {row?.marketType ? MarketTypeMap[row.marketType] : '-'} */}
            {row.marketName ||
              MarketTypeMap[row.marketType] ||
              MarketTypeByEnumMap[row.marketType] ||
              '-'}
          </span>
        </TableCell>
        <TableCell align="left">
          <div
            className={
              row.amount > 0
                ? 'profit mob-fs-16'
                : row.amount < 0
                ? 'loss mob-fs-16'
                : null
            }
          >
            {row.amount > 0
              ? '+' + Number(row.amount.toFixed(2)).toLocaleString('en-US')
              : Number(row.amount.toFixed(2)).toLocaleString('en-US')}
          </div>
          <div className="mob-view mob-fs-13">
            {row.amount === -1 ? '-' : 'Bal: ' + Number(row.amount.toFixed(2)).toLocaleString('en-US')}
          </div>
        </TableCell>
        <TableCell className="web-view" align="left">
          <span className="txt-bldin-mob">
            {row.balanceAfter === -1 ? '-' : Number(row.balanceAfter.toFixed(2)).toLocaleString('en-US')}
          </span>
        </TableCell>
        <TableCell className="web-view" align="left">
          <div className="b-text m-link">{row.transactionId}</div>
        </TableCell>
        <TableCell className="remarks-col web-view" align="left">
          <div className="b-text m-link">
            {row?.remarks ? row?.remarks : '-'}
          </div>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

function Card(props: {
  row: LedgerRecord;
  showTransactionDetails: () => void;
}) {
  const { row, showTransactionDetails } = props;

  return (
    <div className="report-card">
      <IonRow>
        <IonCol sizeXs="3" sizeSm="3" className="card-col">
          <div className="card-col-ctn">
            <div className="amount-card">
              <div
                className={
                  row.amount > 0
                    ? 'profitt mob-fs-16'
                    : row.amount < 0
                    ? 'losss mob-fs-16'
                    : null
                }
              >
                {row.amount > 0
                  ? '+' + row.amount.toFixed(2)
                  : row.amount.toFixed(2)}
              </div>{' '}
            </div>
          </div>
        </IonCol>

        <IonCol sizeXs="5" sizeSm="5" className="card-col">
          <div onClick={showTransactionDetails} className="title">
            {getTransactionNameByID(row.transactionType)}
          </div>
          <div className="tiny-info-text">
            {row.marketType === 1
              ? row.marketName || MarketTypeByID(row.marketType.toString())
              : row.marketType === -1
              ? ''
              : MarketTypeByID(row.marketType.toString())}
          </div>
          <div className="tiny-info-text">
            {moment(row.transactionTime).format('DD-MM-YY, h:mm:ss A')}
          </div>
        </IonCol>
        <IonCol sizeXs="4" sizeSm="4" className="card-col">
          <div className="title">TXN ID: {row.transactionId}</div>
          <div className="tiny-info-text">Event: {row.eventName}</div>
        </IonCol>
      </IonRow>
    </div>
  );
}

const mapDispatchToProps = (dispatch: Function) => {
  return {
    logout: () => dispatch(logout()),
  };
};

export default connect(null, mapDispatchToProps)(Ledger);
